import React from "react";

export default function Icon({ name, size = 16, color = "currentColor", style = {} }) {
  const icons = {
    zap: (
      <path
        d="M13 2L4.09 12.5H11L10 22L19.91 11.5H13L13 2Z"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    ),
    ticket: (
      <>
        <path
          d="M2 9V7a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v2a2 2 0 0 1 0 4v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-2a2 2 0 0 1 0-4Z"
          strokeWidth="1.5"
        />
        <path d="M12 12h.01" strokeWidth="2" strokeLinecap="round" />
      </>
    ),
    book: (
      <>
        <path
          d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2Z"
          strokeWidth="1.5"
        />
      </>
    ),
    server: (
      <>
        <rect x="2" y="2" width="20" height="8" rx="2" strokeWidth="1.5" />
        <rect x="2" y="14" width="20" height="8" rx="2" strokeWidth="1.5" />
        <path d="M6 6h.01M6 18h.01" strokeWidth="2" strokeLinecap="round" />
      </>
    ),
    database: (
      <>
        <ellipse cx="12" cy="5" rx="9" ry="3" strokeWidth="1.5" />
        <path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3" strokeWidth="1.5" />
        <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5" strokeWidth="1.5" />
      </>
    ),
    network: (
      <>
        <rect x="9" y="2" width="6" height="4" rx="1" strokeWidth="1.5" />
        <rect x="2" y="18" width="6" height="4" rx="1" strokeWidth="1.5" />
        <rect x="16" y="18" width="6" height="4" rx="1" strokeWidth="1.5" />
        <path
          d="M12 6v4M12 10H5.5a1 1 0 0 0-1 1v3M12 10h6.5a1 1 0 0 1 1 1v3"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </>
    ),
    plus: <path d="M12 5v14M5 12h14" strokeWidth="1.5" strokeLinecap="round" />,
    x: (
      <path d="M18 6 6 18M6 6l12 12" strokeWidth="1.5" strokeLinecap="round" />
    ),
    search: (
      <>
        <circle cx="11" cy="11" r="8" strokeWidth="1.5" />
        <path d="m21 21-4.35-4.35" strokeWidth="1.5" strokeLinecap="round" />
      </>
    ),
    edit: (
      <>
        <path
          d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5Z"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </>
    ),
    trash: (
      <path
        d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    ),
    alert: (
      <>
        <path
          d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"
          strokeWidth="1.5"
        />
        <path d="M12 9v4M12 17h.01" strokeWidth="1.5" strokeLinecap="round" />
      </>
    ),
    check: (
      <path
        d="M20 6 9 17l-5-5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    ),
    refresh: (
      <>
        <path
          d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M21 3v5h-5"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M8 16H3v5"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </>
    ),
    info: (
      <>
        <circle cx="12" cy="12" r="10" strokeWidth="1.5" />
        <path d="M12 16v-4M12 8h.01" strokeWidth="1.5" strokeLinecap="round" />
      </>
    ),
    clock: (
      <>
        <circle cx="12" cy="12" r="10" strokeWidth="1.5" />
        <path d="M12 6v6l4 2" strokeWidth="1.5" strokeLinecap="round" />
      </>
    ),
    activity: (
      <path
        d="M22 12h-4l-3 9L9 3l-3 9H2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    ),
    link: (
      <>
        <path
          d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </>
    ),
    message: (
      <path
        d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    ),
    globe: (
      <>
        <circle cx="12" cy="12" r="10" strokeWidth="1.5" />
        <path
          d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10Z"
          strokeWidth="1.5"
        />
      </>
    ),
    chevronLeft: (
      <path
        d="m15 18-6-6 6-6"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    ),
    chevronRight: (
      <path
        d="m9 18 6-6-6-6"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    ),
    menu: (
      <path
        d="M3 12h18M3 6h18M3 18h18"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    ),
    layers: (
      <>
        <path
          d="M12 2L2 7l10 5 10-5-10-5Z"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
        <path
          d="M2 17l10 5 10-5"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2 12l10 5 10-5"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </>
    ),
    tag: (
      <>
        <path
          d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"
          strokeWidth="1.5"
        />
        <line
          x1="7"
          y1="7"
          x2="7.01"
          y2="7"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </>
    ),
    cpu: (
      <>
        <rect x="4" y="4" width="16" height="16" rx="2" strokeWidth="1.5" />
        <rect x="9" y="9" width="6" height="6" strokeWidth="1.5" />
        <path
          d="M9 1v3M15 1v3M9 20v3M15 20v3M1 9h3M1 15h3M20 9h3M20 15h3"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </>
    ),
    building: (
      <>
        <rect x="3" y="9" width="18" height="13" rx="1" strokeWidth="1.5" />
        <path
          d="M8 22V12h8v10M3 9l9-7 9 7"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </>
    ),
    filter: (
      <path
        d="M22 3H2l8 9.46V19l4 2v-8.54L22 3z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    ),
    logOut: (
      <>
        <path
          d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16 17l5-5-5-5M21 12H9"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </>
    ),
  };
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      style={{ flexShrink: 0, ...style }}
      aria-hidden="true"
    >
      {icons[name] || null}
    </svg>
  );
}
